import {Fragment} from 'react'

import {useSlideshowContext} from './'
import {SlideshowSlide} from './Slide'
import {GenericCarousel} from '../GenericCarousel'

export const SlideshowContent = () => {
  const {showNext, showPrevious, currentIndex, items} = useSlideshowContext()

  const renderItem = (index: number) => {
    return <SlideshowSlide index={index} />
  }

  return (
    <div className={'relative flex size-full items-center justify-center'}>
      {/* preload images */}
      {items.map((item, index) => (
        <Fragment key={index}>
          <img
            key={`${index}-src`}
            src={item.placeholderSrc}
            alt={item.alt}
            hidden
          />
          {!item.placeholderSrc && (
            <img
              key={`${index}-placeholder`}
              src={item.src}
              alt={item.alt}
              hidden
            />
          )}
        </Fragment>
      ))}
      <GenericCarousel
        itemClassName={'size-full'}
        index={currentIndex}
        showPrevious={showPrevious}
        showNext={showNext}
        renderItem={renderItem}
        shouldHandleArrowKeys={true}
      />
    </div>
  )
}
